import * as HttpService from "../../../../service/HttpService";

/**
 * 查询用电单位
 */
export const queryElectricityUnit = () => {
    return HttpService.get(HttpService.DOMAIN + "/distributionMeter/unitList");
};

/**
 * 电费模板时间段选择
 */
export const getPeidianTmplTimesList = () => {
    return HttpService.post(HttpService.DOMAIN + "/peidianTmplBilling/getPeidianTmplTimesList");
};


/**
 * 查询模板
 */
export const getPeidianTmplBillingVoList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/peidianTmplBilling/getPeidianTmplBillingVoList",params);
};

/**
 * 查询模板详情
 */
export const getTmplDetails = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/peidianTmplBilling/getTmplDetails",params);
};

/**
 * 查询模板
 */
export const handelQueryWaterlList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/peidianTmplBilling/getWaterTmplList",params);
};

/**
 * 新增电费模板
 */
export const insertTmplMeteringBilling = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/peidianTmplBilling/insertTmplMeteringBilling",params);
};

/**
 * 新增水费模板
 */
export const insertTmplWater = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/peidianTmplBilling/insertTmplWater",params);
};

/**
 * 修改电费模板
 */
export const updateTmplMeteringBilling = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/peidianTmplBilling/updateTmplMeteringBilling",params);
};
/**
 * 修改水费模板
 */
export const updateTmplWater = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/peidianTmplBilling/updateTmplWater",params);
};

/**
 * 删除电费模板
 */
export const deletePkgMeteringBillingElecList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/peidianTmplBilling/deletePkgMeteringBillingElecList",params);
};

/**
 * 删除水费模板
 */
export const deleteWaterTmpl = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/peidianTmplBilling/deleteWaterTmpl",params);
};
